/* eslint-disable max-lines */
import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'Πίσω',
      changePassword: 'Αλλαγή',
      copiedVaultId: 'Αντιγράφηκε!',
      copyVaultID: 'Αντιγραφή του αναγνωριστικού Vault',
      create: 'Δημιουργία',
      next: 'Επόμενο',
      notSure: 'Δεν είμαι σίγουρος/σίγουρη',
      signUp: 'Εγγραφείτε',
      submit: 'Υποβολή',
      updatePassword: 'Ενημέρωση κωδικού πρόσβασης',
    },
    Errors: {
      createReportFailed: 'Η δημιουργία αναφοράς απέτυχε.',
    },
    ReportStatus: {
      CLOSED: 'Έκλεισε',
      INVESTIGATING: 'Διερεύνηση',
      NEW: 'Υποβλήθηκε',
      READ: 'Διαβάστηκε',
    },
    general: {
      navbar: {
        caseSettings: 'Ρυθμίσεις περίπτωσης',
        changePassword: 'Αλλαγή κωδικού πρόσβασης',
        logOut: 'Αποσύνδεση',
        notifications: 'Ειδοποιήσεις',
        notificationsDrawer: {
          appFileScanFailed: 'Ένα αρχείο απέτυχε τον έλεγχο ασφαλείας',
          appReportMatch: 'Η εγγραφή σας στο GoTogether έχει ταιριάξει',
          appReportReassigned: 'Έχει ανατεθεί ένας νέος διαχειριστής υπόθεσης',
          case: 'Θήκη',
          caseAssigned: 'Η υπόθεση ανατέθηκε σε εσάς',
          caseImporterJobCompleted: {
            PartialSuccess:
              'Η εισαγωγή της υπόθεσής σας ολοκληρώθηκε με σφάλματα',
            failure: 'Η εισαγωγή της υπόθεσής σας απέτυχε',
            success: 'Η εισαγωγή της υπόθεσής σας ολοκληρώθηκε με επιτυχία',
          },
          caseLinked: 'Συνδεδεμένη υπόθεση',
          caseTeamInvite: 'Προστέθηκε στην υπόθεση',
          caseUnlinked: 'Η υπόθεση αποσυνδέθηκε',
          dataSanitisation: 'Λεπτομέρειες αναφοράς ενημερώθηκαν',
          emptyDescription: 'Ελέγξτε ξανά αργότερα για νέες ειδοποιήσεις',
          emptyTitle: 'Είσαι ενημερωμένος για όλα',
          importId: 'Εισαγωγή ID:',
          learnMore: 'Μάθετε περισσότερα',
          markAllAsRead: 'Σημείωσε όλα ως αναγνωσμένα',
          newMessage: 'Νέο μήνυμα',
          newReport: 'Λήφθηκε νέα αναφορά',
          permissionRemoved: 'Αφαιρέθηκε από την υπόθεση',
          postSSubmissionFile: 'Προστέθηκαν αρχείο(α) αποδείξεων',
          report: 'Αναφορά',
          reportAssigned: 'Αναφορά που σας έχει ανατεθεί',
          reportStatusChange: 'Η κατάσταση της αναφοράς άλλαξε',
          reporterAnonymised: 'Τα στοιχεία σας έχουν ανωνυμοποιηθεί',
          reporterReportSubmitted: {
            subtitle:
              'Συνιστούμε να αποθηκεύσετε ένα αντίγραφο της αναφοράς σας',
            title: 'Υποβλήθηκε έκθεση',
          },
          mitigationPlanReminder: 'Απαιτείται έγκριση σχεδίου μετριασμού',
          staleCase: 'Ανεκμετάλλευτη υπόθεση',
        },
        privacyStatement: 'Δήλωση ιδιωτικότητας',
        reporter: {
          myReports: 'Οι αναφορές μου',
        },
        settings: 'Ρυθμίσεις',
        technicalSupport: 'Τεχνική υποστήριξη',
        title: 'Λογαριασμός',
      },
      time: {
        day: 'Ημέρα',
        days: 'Ημέρες',
        hour: 'Ώρα',
        hours: 'Ώρες',
        minute: 'Λεπτό',
        minutes: 'Λεπτά',
        second: 'Δεύτερο',
        seconds: 'Δευτερόλεπτα',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'Ανώνυμα',
        autoTranslate:
          'Η αυτόματη μετάφραση είναι απενεργοποιημένη βάσει προεπιλογής.',
        backToMessages: 'Επιστροφή στα μηνύματα',
        caseSettings: 'Ρυθμίσεις υπόθεσης.',
        changeInProfile:
          'Εάν επιθυμείτε να αλλάξετε τη ρύθμιση αυτή, μπορείτε να το κάνετε στο προφίλ σας. ',
        deletedByMessage: 'Διαγράφηκε από {{author}}',
        deletedMessageLabel: 'Αυτό το μήνυμα διαγράφηκε',
        description:
          'Όταν η αυτόματη μετάφραση είναι ενεργοποιημένη, όλα τα μηνύματα της αναφοράς θα μεταφράζονται αυτόματα χρησιμοποιώντας τεχνητή νοημοσύνη, με βάση την προεπιλεγμένη γλώσσα που έχει επιλεγεί στο πρόγραμμα περιήγησής σας.',
        descriptionSecondHalf:
          'Η αρχική έκδοση όλων των μηνυμάτων διατηρείται πάντα και μπορεί να βρεθεί στη συνομιλία.',
        messagePlaceholder: 'Αρχίστε να πληκτρολογείτε...',
        messageSettings: 'Ρυθμίσεις μηνυμάτων.',
        originalMessages: 'Αρχικό',
        showMoreBanner: 'Μάθετε περισσότερα για τις αυτόματες μεταφράσεις',
        titlev2: 'Διαβάστε όλα τα μηνύματα στη γλώσσα της προτίμησής σας.',
        translatedMessageLabel: 'Μεταφρασμένο μήνυμα',
        translatedMessages: 'Μεταφρασμένο',
        understood: 'Κατανοήθηκε',
      },
      Country: {
        description: 'Σε ποια χώρα εδρεύετε;',
        header: 'Σε ποια χώρα εδρεύετε;',
        noOptions: 'Δεν βρέθηκαν χώρες',
        other: 'Άλλο',
        placeholder: 'Αναζήτηση χώρας...',
      },
      CreatePublicReport: {
        createReport: 'Δημιουργία αναφοράς',
        helpPage: 'Μεταβείτε στη σελίδα βοήθειας που διαθέτουμε',
        loginToOpr: 'Σύνδεση για παρακολούθηση αναφορών',
        or: 'ή',
        passwordPlaceholder: 'Εισαγωγή κωδικού πρόσβασης',
        phoneNumberLoginFailed:
          'Η σύνδεση απέτυχε. Λάθος αριθμός τηλεφώνου/PIN',
        phoneNumberPlaceholder: 'Εισαγάγετε τον αριθμό τηλεφώνου σας',
        phoneNumberTooltip:
          'Εισαγάγετε τον αριθμό τηλεφώνου που χρησιμοποιήσατε για να επικοινωνήσετε με την VaultTalk',
        pinPlaceholder: 'Εισαγάγετε PIN',
        reportIntroductionParagraph1:
          'Όταν αναφέρετε ένα περιστατικό, θα σας υποβληθούν μερικές ερωτήσεις που θα σας βοηθήσουν να καταγράψετε την εμπειρία σας.',
        reportIntroductionParagraph2:
          'Πριν από την υποβολή, έχετε την επιλογή να παραμείνετε ανώνυμοι για να προστατεύσετε το απόρρητό σας.',
        reportIntroductionParagraph3:
          'Μετά την υποβολή, μπορείτε να συνδεθείτε ανά πάσα στιγμή για να δείτε την πρόοδο της αναφοράς σας και να μιλήσετε με έναν διαχειριστή υποθέσεων.',
        reportIssue: 'Αναφέρετε ένα θέμα',
        usernameLoginFailed:
          'Η σύνδεση απέτυχε. Λάθος όνομα χρήστη/κωδικός πρόσβασης.',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired: 'Απαιτείται σχέση με την εταιρεία',
            reportedCategoryRequired: 'Απαιτείται η κατηγορία που αναφέρθηκε',
          },
        },
        vaultId: 'Αναγνωριστικό Vault',
        vaultIdPlaceholder: 'Εισαγάγετε το email ή το Αναγνωριστικό Vault σας',
        vaultIdTooltip:
          'Για τις ανώνυμες αναφορές το Αναγνωριστικό Vault είναι αλφαριθμητικό. Εάν η αναφορά δεν ήταν ανώνυμη, το Αναγνωριστικό Vault είναι η διεύθυνση email σας.',
        vaultTalk: 'VaultTalk',
        yourPassword: 'Ο κωδικός πρόσβασής σας',
        yourPhoneNumber: 'Ο αριθμός τηλεφώνου σας',
        yourPin: 'Το 6ψήφιο PIN σας',
        yourVaultId: 'Το Αναγνωριστικό Vault σας',
      },
      CustomHeader: {
        companyLogo: 'Λογότυπο {{company}}',
        openReporting: 'Ανοικτή αναφορά',
        userSettings: 'Ρυθμίσεις χρήστη',
      },
      Date: {
        approximateDescription:
          'Θυμάστε κατά προσέγγιση την ημερομηνία που έλαβε χώρα το συμβάν;',
        approximatePlaceholder:
          'Παράδειγμα: πριν από 6 μήνες/πέρυσι/τον περασμένο Νοέμβριο',
        cancel: 'Ακύρωση',
        clear: 'Εκκαθάριση',
        description: 'Θυμάστε την ημερομηνία που έλαβε χώρα το συμβάν;',
        header: 'Ποια ημέρα πραγματοποιήθηκε;',
        ok: 'Εντάξει',
        placeholder: 'Παράδειγμα: 21 Ιουνίου 2020',
      },
      Description: {
        whatHappened: 'Τι συνέβη;',
        whatHappenedPlaceholder: 'Πείτε το με δικά σας λόγια...',
        whatHappenedText: 'Με δικά σας λόγια, περιγράψτε τι συνέβη',
      },
      Details: {
        disclaimer:
          'Τα στοιχεία αυτά θα γνωστοποιηθούν με την αναφορά σας. Εάν επιθυμείτε να παραμείνετε ανώνυμοι, βεβαιωθείτε ότι δεν περιέχουν στοιχεία ταυτοποίησης.',
        emailPlaceholder: 'Email (προαιρετικό)',
        fullNamePlaceholder: 'Ονοματεπώνυμο (προαιρετικό)',
        header: 'Τα στοιχεία σας',
        nonAnonSubtitle:
          'Παρακαλώ παράσχετε είτε το όνομά σας είτε μια διεύθυνση email. Εάν θέλετε να λαμβάνετε ειδοποιήσεις σχετικά με αυτή την αναφορά, προσθέστε μια κατάλληλη διεύθυνση email παρακάτω.',
        nonOptionalEmailPlaceholder: 'Ηλεκτρονικό Ταχυδρομείο',
        nonOptionalFullNamePlaceholder: 'Ονοματεπώνυμο',
        subtitle:
          'Εάν θέλετε να λαμβάνετε ειδοποιήσεις σχετικά με την παρούσα αναφορά, προσθέστε μια κατάλληλη διεύθυνση email παρακάτω.',
      },
      Emotion: {
        description: 'Πώς σας έκανε να νιώσετε; Ποιος ήταν ο αντίκτυπος;',
        header: 'Ποιος ήταν ο αντίκτυπος;',
        placeholder: 'Αρχίστε να πληκτρολογείτε...',
      },
      Evidence: {
        addedHeading: 'Προστέθηκε',
        deletedMessage: 'διαγράφηκε',
        deletedStatus: 'Διαγράφηκε',
        failedToOpenFileMessage:
          'Απέτυχε να ανοίξει το αρχείο. Προσπαθήστε ξανά.',
        fileStatuses: {
          infectedUpload: 'Επισημάνθηκε από τον έλεγχο ασφαλείας',
          passedUpload: 'Πέρασε τον έλεγχο ασφαλείας',
          pendingUpload: 'Έλεγχος ασφαλείας σε εξέλιξη',
          readyForDownload: 'Έτοιμο για λήψη',
        },
        mobileErrorMessage:
          'Επισημασμένα αρχεία: στείλτε μήνυμα στον διαχειριστή της υπόθεσής σας',
        nameHeading: 'Όνομα',
        statusHeading: 'Κατάσταση',
        tableTitle: 'Αποδεικτικών στοιχείων',
        webErrorMessage:
          'Επισημασμένα αρχεία: Εάν το/τα αρχείο(-α) σας έχει επισημανθεί, στείλτε μήνυμα στον διαχειριστή της υπόθεσης.',
      },
      FileUpload: {
        addFiles: 'Προσθήκη αρχείων',
        addMoreFiles: 'Προσθήκη περισσότερων αρχείων',
        confirm: 'Επιβεβαίωση',
        description:
          'Η προσθήκη αρχείων ως αποδεικτικά στοιχεία μπορεί να βοηθήσει στην αποτελεσματικότητα της επίλυσης από τον διαχειριστή της υπόθεσής σας. Θα πρέπει να εξετάσετε το περιεχόμενο του αρχείου (συμπεριλαμβανομένων των μεταδεδομένων του αρχείου) εάν επιθυμείτε να παραμείνετε ανώνυμοι και να σεβαστείτε τα δικαιώματα άλλων ατόμων και τους ισχύοντες νόμους.',
        dragDrop: 'Αποθέστε τα αρχεία εδώ ή',
        errorMessage:
          'Το/τα αρχείο(-α) απέτυχαν λόγω σφάλματος δικτύου. Κάντε κλικ παρακάτω για να στείλετε μήνυμα στον υπεύθυνο υποθέσεων για βοήθεια',
        fileLimit: 'όριο μεγέθους κάθε αρχείου: 100 MB',
        fileUploadLimitText: 'Μπορείτε να μεταφορτώσετε μόνο 10 αρχεία',
        header: 'Προσθήκη αποδεικτικών στοιχείων',
        helpArticle: 'άρθρο βοήθειας',
        highlighted: 'περιήγηση σε αρχεία',
        information: 'Υποστηριζόμενοι τύποι αρχείων',
        moreInformation:
          'Για περισσότερες πληροφορίες, ανατρέξτε σε αυτό <a>άρθρο βοήθειας</a>',
        postSubmissionErrorMessage:
          'Δεν μπορέσαμε να μεταφορτώσουμε τα αρχεία σας λόγω σφάλματος του συστήματος. Επιλέξτε ξανά «Επιβεβαίωση».',
        tooltipAudio: 'Ήχος:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'Έγγραφα:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'Εικόνες:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'Κείμενο:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'Βίντεο:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'Το αρχείο είναι πολύ μεγάλο',
          invalidFileType: 'Μη υποστηριζόμενος τύπος αρχείου: {{extension}}',
          systemError: 'Σφάλμα συστήματος',
          tooManyFiles: 'Ο μέγιστος αριθμός αρχείων είναι {{maxFiles}}',
        },
        uploadFiles: 'Μεταφόρτωση αρχείων',
      },
      Loading: {
        loading:
          'Περιμένετε μέχρι να υποβάλουμε την αναφορά σας σε έναν διαχειριστή υποθέσεων...',
        postSubmissionLoading:
          'Περιμένετε μέχρι να υποβάλουμε τα αρχεία σας...',
      },
      Location: {
        description: 'Πού συνέβη;',
        header: 'Πού συνέβη;',
        placeholder: 'Παράδειγμα: Στο γραφείο',
      },
      MessageListBox: {
        messageCaseManager: 'Αποστολή μηνύματος στον διαχειριστή της υπόθεσης',
        report: 'Αναφορά {{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'Η μετάφραση απενεργοποιήθηκε',
        enableTranslationLabelEnabled: 'Η μετάφραση ενεργοποιήθηκε',
        enableTranslationsDescription:
          'Ενεργοποιήστε τις αυτόματες μεταφράσεις και διαβάστε όλα τα μηνύματα της αναφοράς στη γλώσσα που προτιμάτε. Η μεταφρασμένη γλώσσα βασίζεται στη γλώσσα που έχετε επιλέξει στη συσκευή σας.',
        enableTranslationsHeader:
          'Ενεργοποίηση αυτόματων μεταφράσεων για μηνύματα αναφοράς',
        enableTranslationsSubDescriptionv2:
          'Μπορείτε να εναλλάσσεστε μεταξύ της μεταφρασμένης και της πρωτότυπης γλώσσας σε κάθε συνομιλία.',
        updateTranslationFailed: 'Η ενημέρωση της μετάφρασης απέτυχε',
        updateTranslationSuccess:
          'Η ρύθμιση της μετάφρασης ενημερώθηκε επιτυχώς',
      },
      Password: {
        changePasswordHeader: 'Αλλαγή',
        createNewPassword: 'Δημιουργήστε έναν νέο κωδικό πρόσβασης',
        createPasswordHeader: 'Ο κωδικός πρόσβασής σας',
        currentPasswordPlaceholder: 'Εισαγάγετε τον τρέχοντα κωδικό πρόσβασης',
        description:
          'Ένας έγκυρος κωδικός πρόσβασης πρέπει να αποτελείται από τουλάχιστον 9 χαρακτήρες και να περιλαμβάνει ένα κεφαλαίο γράμμα και έναν αριθμό',
        enterCurrentPassword: 'Εισαγάγετε τον τρέχοντα κωδικό πρόσβασής σας',
        forgottenPasswordInstructions:
          'Εισάγετε τον αλφαριθμητικό σας κωδικό Vault ID (όχι τη διεύθυνση email σας) και τη διεύθυνση email για να επαναφέρετε τον κωδικό σας.',
        newDescription:
          'Δημιουργήστε έναν ισχυρό κωδικό πρόσβασης για να διατηρήσετε τον λογαριασμό σας ασφαλή. Αρχίστε να πληκτρολογείτε για να δείτε τις παρακάτω οδηγίες.',
        passwordPlaceholder: 'Δημιουργία κωδικού πρόσβασης',
        passwordResetRequestedDescription:
          'Εάν το ID του Vault υπάρχει στο σύστημά μας, θα λάβετε ένα email με οδηγίες για την επαναφορά του κωδικού σας.',
        passwordResetRequestedHeader:
          'Ζητήθηκε σύνδεσμος επαναφοράς κωδικού πρόσβασης',
        reenterPlaceholder: 'Εισαγάγετε ξανά τον κωδικό πρόσβασης',
        subtitle:
          'Δημιουργήστε έναν κωδικό πρόσβασης για υποβολή αυτής της αναφοράς και πρόσβαση σε αυτήν στο μέλλον',
        yourVaultId: 'Το ID του Vault σας',
        yourVaultIdPlaceholder:
          'Εισάγετε το αναγνωριστικό σας Vault (π.χ. {{exampleId}})',
      },
      Perpetrators: {
        description:
          'Αναφέρετε ένα συγκεκριμένο άτομο ή πολλά άτομα; Μπορείτε να τα κατονομάσετε ή να τα περιγράψετε;',
        header: 'Συμμετέχοντες',
        placeholder:
          'Αρχίστε να πληκτρολογείτε και χρησιμοποιήστε κόμμα για να προσθέσετε πολλαπλά ονόματα ή περιγραφές.',
      },
      PoweredByVault: 'Με την υποστήριξη της {{company}}',
      PrivacyStatement: 'Δήλωση απορρήτου προϊόντος',
      PublicMessageList: {
        myMessages: 'Τα μηνύματά μου',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader:
          'Αποδεικτικά στοιχεία που προστέθηκαν στην υπάρχουσα αναφορά',
        backToReportId: 'Επιστροφή στο Αναγνωριστικό αναφοράς: {{reportId}}',
        description:
          'Η προσθήκη αρχείων ως αποδεικτικά στοιχεία μπορεί να βοηθήσει στην αποτελεσματικότητα της επίλυσης από τον διαχειριστή της υπόθεσής σας. Θα πρέπει να εξετάσετε το περιεχόμενο του αρχείου (συμπεριλαμβανομένων των μεταδεδομένων του αρχείου) εάν επιθυμείτε να παραμείνετε ανώνυμοι και να σεβαστείτε τα δικαιώματα άλλων ατόμων και τους ισχύοντες νόμους. Για περισσότερες πληροφορίες, δείτε αυτήν τη <a>άρθρο βοήθειας</a>',
        header: 'Προσθέστε επιπλέον αποδεικτικά στοιχεία στην αναφορά',
        vaultTalkOpenCaseHeader:
          'Προσθέστε αποδεικτικά στοιχεία στην αναφορά σας',
      },
      PublicReport: {
        anonymous: 'Ανώνυμα',
        backToReports: 'Επιστροφή στις αναφορές',
        skipped: 'Παραλήφθηκε',
      },
      PublicReportCard: {
        addEvidence: 'Προσθέστε επιπλέον αποδεικτικά στοιχεία',
        messageCaseManager: 'Αποστολή μηνύματος στον διαχειριστή της υπόθεσης',
        reportId: 'Αναγνωριστικό αναφοράς:',
        submitted: 'Υποβλήθηκε',
        vaultTalkClosedCaseCTA: 'Προβολή αποδεικτικών στοιχείων',
        vaultTalkOpenCaseCTA: 'Προσθήκη αποδεικτικών στοιχείων',
        viewAdditionalEvidence: 'Προβολή πρόσθετων αποδεικτικών στοιχείων',
        viewReport: 'Προβολή αναφοράς',
      },
      PublicReportsList: {
        reportingSystem: 'Σύστημα αναφοράς',
      },
      Question: {
        placeholder: 'Αρχίστε να πληκτρολογείτε...',
        question: 'Παρέχετε λεπτομέρειες',
        questionText:
          'Μοιραστείτε μαζί μας την ανησυχία, την ενημέρωση ή την απορία σας',
      },
      Relationship: {
        header: 'Η σχέση σας με τον οργανισμό',
        tellUsAbout: 'Πείτε μας για τη σχέση σας με τον οργανισμό.',
      },
      ResponsiveNavMenu: {
        messages: 'Τα μηνύματά μου',
        reports: 'Οι αναφορές μου',
      },
      Site: {
        description: 'Σε ποια τοποθεσία εδρεύετε;',
        header: 'Σε ποια τοποθεσία εδρεύετε;',
        noOptions: 'Δεν βρέθηκαν τοποθεσίες',
        other: 'Άλλο',
        placeholder: 'Αναζήτηση τοποθεσίας...',
      },
      SpamPuzzle: {
        dialog: 'Για να συνεχίσετε, λύστε αυτό το παζλ',
      },
      SubmissionTypes: {
        reportIssue: 'Επιλέξτε μια κατηγορία',
        whatType:
          'Επιλέξτε την κατηγορία που περιγράφει καλύτερα την αναφορά σας',
      },
      SubmitSuccess: {
        category: '<bold>Κατηγορία:</bold> {{category}}',
        country: '<bold>Χώρα:</bold> {{country}}',
        dateSubmitted: '<bold>Ημερομηνία υποβολής:</bold> {{date}}',
        recordYourVaultID: 'Απομνημόνευση αυτών των πληροφοριών για σύνδεση',
        successInformation: 'Περισσότερες πληροφορίες',
        successMessage:
          'Η αναφορά σας έχει υποβληθεί και είναι έτοιμη για έλεγχο. Τυχόν συνημμένα αρχεία που απαιτούν προσοχή θα επισημανθούν κατά τη σύνδεση. Συνδεθείτε παρακάτω για να δείτε ενημερώσεις αναφορών και να στείλετε μήνυμα στον διαχειριστή υποθέσεων.',
        successSanitationMessage:
          'Αποθηκεύστε ένα αντίγραφο για τα αρχεία σας, και κρατήστε το Vault-ID σας ασφαλές - θα το χρειαστείτε για να έχετε πρόσβαση σε ενημερώσεις και για να στείλετε μήνυμα στο διαχειριστή της υπόθεσής σας.',
        successSanitationTagline:
          'Η αναφορά σας υποβλήθηκε και αποθηκεύτηκε με ασφάλεια.',
        successThankYou: 'Σας ευχαριστώ για την αναφορά σας!',
        viewReport: 'Προβολή αναφοράς',
      },
      Time: {
        approximateDescription:
          'Θυμάστε κατά προσέγγιση την ώρα που έλαβε χώρα το συμβάν;',
        approximatePlaceholder: 'Παράδειγμα: το πρωί, το απόγευμα',
        description: 'Θυμάστε την ώρα που έλαβε χώρα το συμβάν;',
        header: 'Τι ώρα συνέβη;',
        invalidTime: 'Η μορφή ώρας πρέπει να είναι ΩΩ:ΛΛ',
      },
      UserSettingsDialog: {
        changePassword: 'Αλλαγή κωδικού πρόσβασης',
        closeDialog: 'Κλείσιμο διαλόγου',
        logout: 'Αποσύνδεση',
        messageSettings: 'Ρυθμίσεις μηνυμάτων',
        userSettings: 'Ρυθμίσεις χρήστη',
      },
      Witnesses: {
        description: 'Το είπατε σε κανέναν άλλον ή είδε κανείς τι συνέβη;',
        header: 'Υπάρχουν μάρτυρες;',
        placeholder: 'Αρχίστε να πληκτρολογείτε...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'Στείλτε μήνυμα',
        title: 'Μήνυμα Διαχειριστή Υπόθεσης',
        translationHeader: 'Μάθετε περισσότερα για τις αυτόματες μεταφράσεις',
      },
      ReportCard: {
        addEvidence: 'Προσθέστε αποδείξεις',
        submissionModeVia: 'μέσω {{submissionMode}}',
        viewEvidence: 'Προβολή αποδείξεων',
      },
      ReportList: {
        yourReports: 'Οι Αναφορές σας',
      },
      ReportingActivate: {
        buttonText: 'Συνέχεια',
        description:
          'Εάν ο οργανισμός σας σας έχει καταχωρίσει για έναν λογαριασμό, θα σας στείλουμε ένα email με οδηγίες για να ολοκληρώσετε την εγκατάσταση.',
        emailInput: 'Email',
        header: 'Εισαγάγετε το επαγγελματικό email σας',
        successAccount:
          'Εάν ο οργανισμός σας σας έχει εγγράψει για έναν λογαριασμό, θα σας στείλουμε ένα email με οδηγίες για την ολοκλήρωση της εγκατάστασης.',
        successEmail:
          'Αν δεν το δείτε αμέσως, παρακαλώ περιμένετε λίγα λεπτά και ανανεώστε τον φάκελο εισερχομένων του email σας.',
        successHeading: 'Σας ευχαριστούμε',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'Προσθέστε αποδείξεις στην αναφορά σας',
        descriptionText:
          'Η προσθήκη αρχείων ως αποδεικτικά στοιχεία μπορεί να βοηθήσει στην αποτελεσματικότητα της επίλυσης από τον υπεύθυνο της υπόθεσής σας. Σας παρακαλούμε να εξετάσετε το περιεχόμενο του αρχείου (συμπεριλαμβανομένων των μεταδεδομένων του αρχείου) αν επιθυμείτε να παραμείνετε ανώνυμοι, και να σεβαστείτε τα δικαιώματα των άλλων ατόμων και τους ισχύοντες νόμους. Για περισσότερες πληροφορίες, παρακαλώ δείτε αυτό το <a>άρθρο βοήθειας</a>',
        emptyMessage: 'Δεν έχουν ανέβει επιπλέον αποδείξεις',
      },
      ReportingChangePassword: {
        back: 'Πίσω',
        description:
          'Δημιουργήστε έναν ισχυρό κωδικό πρόσβασης για να διατηρήσετε τον λογαριασμό σας ασφαλή. Ξεκινήστε να πληκτρολογείτε για να δείτε τις οδηγίες παρακάτω.',
        errorToast:
          'Δεν μπορεί να δημιουργηθεί κωδικός πρόσβασης, μη έγκυρο διακριτικό.',
        header: 'Αλλαγή Κωδικού',
        incorrectCurrentPassword:
          'Ο τρέχων κωδικός πρόσβασης είναι λάθος. Παρακαλώ ελέγξτε τον και προσπαθήστε ξανά.',
        invalidToken: 'Μη έγκυρο διακριτικό',
        passwordUpdated: 'Ο κωδικός πρόσβασης ενημερώθηκε',
        passwordUpdatedDescription:
          'Ο κωδικός σας έχει ενημερωθεί επιτυχώς. Ευχαριστούμε για το βήμα αυτό για να διατηρήσετε τα δεδομένα σας ασφαλή!',
        passwordUsedBefore:
          'Δεν επιτρέπεται η επαναχρησιμοποίηση κωδικού πρόσβασης',
        passwordUsedBeforeDescription:
          'Για την ασφάλειά σας, δεν μπορείτε να επαναχρησιμοποιήσετε κανένα από τα τελευταία σας έξι κωδικούς πρόσβασης. Παρακαλούμε επιλέξτε έναν νέο, μοναδικό κωδικό πρόσβασης για να διατηρήσετε τον λογαριασμό σας ασφαλή και δοκιμάστε ξανά.',
        toastDescription:
          'Ο κωδικός σας έχει ενημερωθεί επιτυχώς. Ευχαριστούμε που πραγματοποιήσατε αυτό το βήμα για να διατηρήσετε τα δεδομένα σας ασφαλή!',
        toastMessage: 'Ο κωδικός πρόσβασης ενημερώθηκε',
        updatePasswordCTA: 'Ενημέρωση κωδικού πρόσβασης',
      },
      ReportingConnect: {
        cancelButton: 'Ακύρωση',
        connectButton: 'Σύνδεση',
        disclaimer:
          'Η σύνδεση του λογαριασμού σας στο Slack με τον λογαριασμό σας στο Vault εξασφαλίζει μια ασφαλή και ιδιωτική σύνδεση. <br /> <br /> Συνδεόμενοι, μπορείτε να αναφέρετε κακή συμπεριφορά ή να κάνετε μια ερώτηση απευθείας μέσα στο Slack. Θα έχετε πάντα την επιλογή να αναφέρετε ανώνυμα μετά τη σύνδεση. Η ιδιωτικότητα και η ασφάλειά σας είναι οι κορυφαίες μας προτεραιότητες.',
        heading:
          ' Η Vault Platform ζητά άδεια πρόσβασης στον λογαριασμό σας {{organisationName}} Slack ',
        listHeading: 'Τι θα μπορεί να κάνει ο Vault;',
        permissionIdentity: {
          extraInfo:
            'Το Vault θα έχει τη δυνατότητα να βλέπει την ταυτότητα του χρήστη σας Slack',
          heading: 'Προβολή πληροφοριών σχετικά με την ταυτότητα ενός χρήστη',
        },
        permissionNotifications: {
          extraInfo:
            'Το Vault θα μπορεί να σας στέλνει ειδοποιήσεις στον λογαριασμό Slack, σχετικά με τυχόν ενημερώσεις σε μια υποβληθείσα αναφορά ή ερώτηση',
          heading: 'Αποστολή ειδοποιήσεων',
        },
        permissionOverview: {
          extraInfo:
            'Το Vault θα εμφανίσει επισκόπηση όλων των υποβολών στην αρχική σελίδα',
          heading: 'Επισκόπηση των υποβολών',
        },
        permissionSubmitReport: {
          extraInfo:
            'Αυτό θα παρέχει στο Vault το δικαίωμα να υποβάλει μια αναφορά ή να θέσει μια ερώτηση, απευθείας στον οργανισμό σας, από το Slack.',
          heading: 'Υποβάλετε μια αναφορά ή μια ερώτηση εκ μέρους σας',
        },
        successfulConnectionDescription:
          'Ο λογαριασμός σας στο Vault και ο λογαριασμός σας στο Slack είναι πλέον συνδεδεμένοι. Μπορείτε τώρα να κλείσετε αυτήν την καρτέλα και να επιστρέψετε στο Slack.',
        successfulConnectionHeading: 'Συνδεθήκατε επιτυχώς',
        unsuccessfulConnectionDescription:
          'Κάτι πήγε στραβά. Παρακαλώ κλείστε αυτήν την καρτέλα και επιστρέψτε στο Slack για να δοκιμάσετε ξανά.',
        unsuccessfulConnectionHeading: 'Η σύνδεση απέτυχε',
      },
      ReportingForgotPassword: {
        description:
          'Εισάγετε τη διεύθυνση email που σχετίζεται με τον λογαριασμό σας και θα σας στείλουμε έναν σύνδεσμο για να επαναφέρετε τον κωδικό σας.',
        heading: 'Ξεχασμένος κωδικός πρόσβασης',
        invalidTokenError:
          'Δεν μπορεί να δημιουργηθεί κωδικός πρόσβασης, μη έγκυρο διακριτικό.',
        passwordReuseError:
          'Δεν επιτρέπεται η επαναχρησιμοποίηση κωδικού πρόσβασης',
        passwordReuseErrorDescription:
          'Για την ασφάλειά σας, δεν μπορείτε να χρησιμοποιήσετε κανένα από τα τελευταία σας έξι κωδικούς πρόσβασης. Παρακαλούμε, επιλέξτε έναν νέο, μοναδικό κωδικό πρόσβασης για να διατηρήσετε το λογαριασμό σας ασφαλή και προσπαθήστε ξανά.',
        sendLink: 'Στείλτε σύνδεσμο επαναφοράς',
        sendLinkFailure: 'Κάτι πήγε στραβά',
        sendLinkFailureDescription:
          'Επιστρέψτε στο <a>Reporter Hub</a> και δοκιμάστε ξανά. Αν το πρόβλημα συνεχίζεται, επικοινωνήστε μαζί μας στο <mailto>techsupport@vaultplatform.com</mailto>',
        sendLinkSuccess: 'Σύνδεσμος επαναφοράς κωδικού πρόσβασης εστάλη',
        sendLinkSuccessDescription:
          'Έχουμε στείλει έναν σύνδεσμο επαναφοράς κωδικού πρόσβασης στο {{email}}',
        updatePasswordSuccess: 'Ο κωδικός πρόσβασης ενημερώθηκε',
        updatePasswordSuccessDescription:
          'Ο κωδικός σας έχει ενημερωθεί με επιτυχία. Ευχαριστούμε που πραγματοποιήσατε αυτό το βήμα για να διατηρήσετε τα δεδομένα σας ασφαλή!',
      },
      ReportingLogin: {
        accountFrozen: 'Ο λογαριασμός είναι παγωμένος',
        accountLocked:
          'Η σύνδεση έχει προσπαθήσει πάρα πολλές φορές λανθασμένα. Ο λογαριασμός είναι κλειδωμένος για μέχρι και 1 ώρα. Δεν είναι δυνατή η επαναφορά του κωδικού πρόσβασης κατά τη διάρκεια αυτού του χρόνου.',
        accountLockedPermanently:
          'Ο λογαριασμός σας έχει κλειδωθεί. Χρησιμοποιήστε την επαναφορά κωδικού πρόσβασης για να ανακτήσετε την πρόσβαση ή επικοινωνήστε με τον διαχειριστή του συστήματος σας για περαιτέρω βοήθεια.',
        createAccountCTA: 'Εγγραφείτε για έναν λογαριασμό',
        currentPassword: 'Τρέχων Κωδικός',
        emailLabel: 'Το Email σας',
        forgotPassword: 'Ξεχάσατε τον κωδικό σας;',
        loginButton: 'Σύνδεση',
        newPasswordPlaceholder: 'Νέος κωδικός πρόσβασης',
        passwordFailMessage:
          'Επιστρέψτε στην εφαρμογή Vault στο Slack και δοκιμάστε ξανά. Αν το πρόβλημα συνεχίζεται, επικοινωνήστε μαζί μας στο techsupport@vaultplatform.com.',
        passwordFailTitle: 'Κάτι πήγε λάθος',
        passwordLabel: 'Ο κωδικός σου',
        passwordPlaceholder: 'Εισάγετε τον κωδικό σας',
        passwordResetRequired: 'Απαιτείται επαναφορά κωδικού πρόσβασης',
        passwordSuccessfullySetMessage:
          'Επιστρέψτε στην εφαρμογή Vault στο Slack και πραγματοποιήστε έλεγχο ταυτότητας με τον νέο κωδικό πρόσβασής σας για να συνεχίσετε από εκεί που σταματήσατε.',
        passwordSuccessfullySetTitle: 'Ο κωδικός πρόσβασης ορίστηκε επιτυχώς',
        reenterPlaceholder: 'Εκ νέου εισαγωγή κωδικού πρόσβασης',
        title: 'Κέντρο Ρεπόρτερ',
        tooltip:
          'Εάν δεν έχετε ορίσει ακόμη κωδικό πρόσβασης για την εφαρμογή Vault, ακολουθήστε εδώ για να ξεκινήσετε. Αν έχετε ξεχάσει τον κωδικό σας, χρησιμοποιήστε τον σύνδεσμο "Ξέχασες τον κωδικό;" παρακάτω.',
        usernameLoginFailed:
          'Η σύνδεση απέτυχε. Λάθος όνομα χρήστη ή κωδικός πρόσβασης.',
      },
      ReportingReset: {
        failureDescription:
          'Επιστρέψτε στην εφαρμογή Vault στο Slack και δοκιμάστε ξανά. Εάν το πρόβλημα συνεχίζεται, επικοινωνήστε μαζί μας στο <mailto>techsupport@vaultplatform.com</mailto>',
        failureHeading: 'Κάτι πήγε στραβά',
        successDescription:
          'Επιστρέψτε στην εφαρμογή Vault στο Slack και επαληθεύστε με τον νέο σας κωδικό πρόσβασης για να συνεχίσετε εκεί που είχατε μείνει.',
        successHeading: 'Ο κωδικός πρόσβασης ορίστηκε επιτυχώς',
      },
      noReports: {
        description:
          'Όλες οι υποβληθείσες αναφορές θα εμφανίζονται εδώ. Μάθετε περισσότερα για τους τρόπους που μπορείτε να υποβάλετε μια αναφορά στο',
        descriptionHelpArticle: 'αυτό το άρθρο βοήθειας',
        errorDescription:
          'Δυσκολευόμαστε να φορτώσουμε τις αναφορές σας. Δοκιμάστε να ανανεώσετε τη σελίδα.',
        errorDescriptionSecondary:
          'Εάν αυτό δεν λειτουργεί, παρακαλούμε επικοινωνήστε μαζί μας στο',
        errorTitle: '⚠️ Ωχ, κάτι πήγε στραβά',
        title: 'Δεν έχετε αναφορές ακόμη',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'Ενεργοποιήστε τις αυτόματες μεταφράσεις και διαβάστε όλα τα μηνύματα αναφοράς στην προτιμώμενη γλώσσα σας. Η μεταφρασμένη γλώσσα βασίζεται στη γλώσσα που έχετε επιλέξει στη συσκευή σας.',
          autoTranslationDescription2:
            'Μπορείτε να αλλάξετε μεταξύ της μεταφρασμένης και της αρχικής γλώσσας σε κάθε συνομιλία.',
          autoTranslationTitle:
            'Ενεργοποιήστε τις αυτόματες μεταφράσεις για τα μηνύματα αναφοράς',
          header: 'Ρυθμίσεις Μηνυμάτων',
          subHeader: 'Ρυθμίστε πώς εμφανίζονται τα μηνύματα',
        },
        notificationSettings: {
          emailDescription:
            'Λάβετε ειδοποιήσεις μέσω email για σημαντικές ενημερώσεις στις αναφορές σας',
          emailTitle: 'Ειδοποιήσεις Email',
          header: 'Ρυθμίσεις Ειδοποιήσεων',
          subHeader: 'Ρυθμίστε τον τρόπο που λαμβάνετε ειδοποιήσεις',
        },
        title: 'Ρυθμίσεις',
        updatedSettingsFailure: 'Απέτυχε η ενημέρωση των ρυθμίσεών σας',
        updatedSettingsSuccess: 'Ενημέρωση των ρυθμίσεών σας επιτυχώς',
      },
    },
    validators: {
      passwordLength:
        'Ο κωδικός πρόσβασης πρέπει να αποτελείται από τουλάχιστον 9 χαρακτήρες',
      passwordLowercase:
        'Ο κωδικός πρόσβασης πρέπει να περιέχει τουλάχιστον 1 πεζό γράμμα',
      passwordMissMatch:
        'Τα πεδία κωδικού πρόσβασης και επιβεβαίωσης πρέπει να ταιριάζουν.',
      passwordNumeric:
        'Ο κωδικός πρόσβασης πρέπει να περιέχει τουλάχιστον 1 αριθμό',
      passwordUppercase:
        'Ο κωδικός πρόσβασης πρέπει να περιέχει τουλάχιστον 1 κεφαλαίο γράμμα',
    },
    validatorsNew: {
      passwordLength: 'Μεταξύ 10 και 30 χαρακτήρων',
      passwordLowercase: 'Τουλάχιστον ένα πεζό γράμμα',
      passwordMissMatch: 'Οι κωδικοί πρόσβασης δεν ταιριάζουν',
      passwordNumeric: 'Τουλάχιστον ένας αριθμός',
      passwordSpecialCharacter: 'Τουλάχιστον ένας ειδικός χαρακτήρας',
      passwordUppercase: 'Τουλάχιστον ένα κεφαλαίο γράμμα',
    },
  },
};

export default translations;
